"use client";
import React, { useRef, useEffect, useState } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import Fancybox from "@/components/FancyboxWrap";
function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

const themes = [
  {
    title: "section1",
    theme: {
      background: "#fff",
    },
  },
  {
    title: "section2",
    theme: {
      background: "#e5e6e7",
    },
  },
  {
    title: "section3",
    theme: {
      background: "#dad8d6",
    },
  },
  {
    title: "section4",
    theme: {
      background: "#fff",
    },
  },
];

export default function Residence() {
  const GroupRef = useRef([]);
  const [openTab, setOpenTab] = useState(1);
  const [openTab2, setOpenTab2] = useState(1);

  const onScroll = (e: Event) => {
    if (GroupRef.current[0] == null) {
      document.body.style.backgroundColor = "white";
    } else {
      const styles: any = GroupRef.current
        .map((item: any, index) => {
          const rect = item.getBoundingClientRect();
          return { item, rect };
        })
        .find((item) => item.rect.bottom >= window.innerHeight * 0.5);

      document.body.style.backgroundColor = `${styles.item.dataset.bgcolor}`;
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll, false);
  }, []);

  function ConditionContent(title: string) {
    if (title == "section1") {
      return (
        <section className="w-full min-h-screen h-full relative overflow-hidden flex justify-center items-end lg:items-center">
          <div className="w-full h-full max-w-7xl  p-4 lg:p-10 flex items-center mt-20 lg:mt-14 2xl:mt-0 ">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 w-full h-full items-center justify-items-center ">
              <div className="w-full h-[65vh] lg:h-[768px]  overflow-hidden relative flex p-2 lg:p-4 border border-[#83603f]">
                <motion.div
                  initial={{ scale: 0.7, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ type: "spring", duration: 3, delay: 0 }}
                  className="w-full h-full relative overflow-hidden"
                >
                  <Image
                    src="/assets/floorplan/DSCF0187-Edit-1.webp"
                    alt="DSCF0187-Edit-1"
                    sizes="100vw"
                    width={0}
                    height={0}
                    className="hover:scale-105 duration-500 w-full h-full object-cover object-center"
                  />
                </motion.div>
              </div>

              <motion.div
                initial={{ scale: 0.7, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", duration: 3, delay: 0 }}
                className="w-full h-full flex justify-center items-center"
              >
                <div className="text-center text-[#7b7c80] grid justify-items-center">
                  <p className="font-serif italic">Unit Matrix</p>
                  <h1 className="font-bold text-3xl lg:text-4xl font-serif text-[#82603f] mb-5">
                    EXCELLENCE
                    <br />
                    IN EVERY PREFERENCE
                  </h1>

                  <div className="hidden lg:block w-full relative h-[500px]  ">
                    <Image
                      src="/assets/floorplan/unit-matrix.webp"
                      alt="unit-matrix"
                      sizes="100vw"
                      width={0}
                      height={0}
                      className="hidden lg:block w-full h-full object-contain object-center"
                    />
                  </div>

                  <div className="visible lg:hidden w-full relative h-[500px] ">
                    <Image
                      src="/assets/floorplan/unit-matrix-mobile.webp"
                      alt="unit-matrix"
                      sizes="100vw"
                      width={0}
                      height={0}
                      className="block lg:hidden w-full h-ful object-contain object-center"
                    />
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    } else if (title == "section2") {
      return (
        <section className=" w-full  h-full relative overflow-hidden flex justify-center items-center flex-col">
          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] mb-5 text-center font-serif">
            MASTER PLAN
          </p>

          <a
            aria-label="masterplan"
            data-fancybox="masterplan"
            href="/assets/floorplan/masterplan.webp"
            className="hidden lg:block w-full max-w-7xl h-[734px] relative "
          >
            <Image
              data-aos="zoom-out-up"
              src="/assets/floorplan/masterplan.webp"
              alt="masterplan"
              sizes="100vw"
              width={0}
              height={0}
              quality={100}
              className="w-full h-full object-contain object-center"
            />
          </a>

          <div className="lg:hidden w-full h-full max-w-7xl  p-4  flex items-center ">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 w-full h-full items-center justify-items-center ">
              <div className="w-full h-[350px] sm:h-[450px] overflow-hidden relative flex p-2 lg:p-4 ">
                <motion.div
                  initial={{ scale: 0.7, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ type: "spring", duration: 3, delay: 0 }}
                  className="w-full h-full relative"
                >
                  <a
                    href="/assets/floorplan/mobile-master.webp"
                    data-fancybox="masterplan"
                    aria-label="masterplan"
                  >
                    <Image
                      data-aos="zoom-out-up"
                      src="/assets/floorplan/mobile-master.webp"
                      alt="masterplan"
                      sizes="100vw"
                      width={0}
                      height={0}
                      className="w-full h-full object-contain object-center"
                    />
                  </a>
                </motion.div>
              </div>

              <motion.div
                initial={{
                  y: "200%",
                }}
                animate={{
                  y: 0,
                  transition: {
                    ease: [0.455, 0.03, 0.515, 0.955],
                    duration: 1,
                  },
                }}
                className="w-full h-full flex justify-center items-center"
              >
                <div className="text-center text-[#7b7c80] grid justify-items-center">
                  <p className="font-serif italic">Master Plan</p>
                  <h1 className="font-bold text-3xl lg:text-4xl font-serif text-[#82603f] mb-5">
                    INNOVATIVE AND VERSATITLE LAYOUT THAT CAPTIVATES ALL
                    FAMILIES
                  </h1>

                  <div className="text-sm max-w-md w-fit font-light text-left">
                    <ul className=" list-decimal">
                      <li> Drop off</li>
                      <li> Main Entrance</li>
                      <li> Residence Lobby</li>
                      <li> Residence Lounge</li>
                      <li> Multi-Purpose Room</li>
                      <li> Fitness Room</li>
                      <li> Male Locker Room</li>
                      <li> Female Locker Room</li>
                      <li> Sauna Room</li>
                      <li> Steam Room</li>
                      <li> Indoor Swimming Pool</li>
                      <li> Onsen</li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    } else if (title == "section3") {
      return (
        <section className=" w-full h-full relative overflow-hidden flex justify-center items-center ">
          <div className="w-full h-full max-w-7xl  p-4 lg:p-10  flex items-center  ">
            <div className="w-full relative  h-full">
              <div className="flex flex-wrap">
                <div className="w-full  h-full flex flex-col items-center">
                  <div className="relative flex flex-col min-w-0 break-words w-full mb-5">
                    <div className="lg:px-6 lg:py-5 flex-auto overflow-hidden">
                      <div className="tab-content tab-space max-h-[728px] h-full">
                        <div
                          className={openTab === 1 ? "flex flex-col" : "hidden"}
                          id="link1"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] mb-5 text-center font-serif">
                            {" "}
                            <span className="">
                              2{" "}
                              <span className="text-sm align-top -ml-2 ">
                                nd{" "}
                              </span>
                            </span>{" "}
                            -{" "}
                            <span className="mr-2">
                              7{" "}
                              <span className="text-sm align-top -ml-2 ">
                                th{" "}
                              </span>
                            </span>{" "}
                            FLOOR PLAN
                          </p>

                          <a
                            data-caption="2nd - 7th FLOOR PLAN"
                            aria-label="masterplan"
                            href="/assets/floorplan/floor-1-image.webp"
                            data-fancybox="floorplan"
                            className="w-full h-[350px] lg:h-[480px] relative"
                          >
                            <Image
                              src="/assets/floorplan/floor-1-image.webp"
                              alt="floor-1-image"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>
                        <div
                          className={openTab === 2 ? "block" : "hidden"}
                          id="link2"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] mb-5 text-center font-serif">
                            {" "}
                            <span className="mr-1">
                              8{" "}
                              <span className="text-sm align-top -ml-2 ">
                                th{" "}
                              </span>
                            </span>{" "}
                            FLOOR PLAN
                          </p>

                          <a
                            data-caption="8th FLOOR PLAN"
                            href="/assets/floorplan/floor-2-image.webp"
                            data-fancybox="floorplan"
                            aria-label="masterplan"
                            className="w-full h-[350px] lg:h-[480px]  relative"
                          >
                            <Image
                              src="/assets/floorplan/floor-2-image.webp"
                              alt="floor-2-image"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul
                    className="flex mb-0 list-none flex-wrap flex-row w-fit justify-center "
                    role="tablist"
                  >
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-48"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab === 1
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(1);
                        }}
                        data-toggle="tab"
                        aria-label="tab 1 click floor plan"
                        href="#link1"
                        role="tablist"
                      >
                        <span className="mr-1">
                          2{" "}
                          <span className="text-xs align-top -ml-[2px]  ">
                            nd
                          </span>
                        </span>{" "}
                        -{" "}
                        <span className="mr-1">
                          7{" "}
                          <span className="text-xs align-top -ml-[2px]  ">
                            th{" "}
                          </span>
                        </span>{" "}
                        Floor Plan
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab === 2
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(2);
                        }}
                        data-toggle="tab"
                        aria-label="tab 2 click floor plan"
                        href="#link2"
                        role="tablist"
                      >
                        <span className="mr-1">
                          8{" "}
                          <span className="text-xs align-top -ml-[2px]  ">
                            th{" "}
                          </span>
                        </span>{" "}
                        Floor Plan
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else if (title == "section4") {
      return (
        <section className=" w-full h-full relative overflow-hidden flex justify-center items-center ">
          <div className="w-full h-full max-w-7xl  p-4 lg:p-10  flex items-center  ">
            <div className="w-full relative  h-full">
              <div className="flex flex-wrap">
                <div className="w-full  h-full flex flex-col items-center">
                  <div className="relative flex flex-col min-w-0 break-words w-full mb-5">
                    <div className="lg:px-6 lg:py-5 flex-auto overflow-hidden">
                      <div className="tab-content tab-space max-h-[728px] h-full">
                        <div
                          className={
                            openTab2 === 1
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link1"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            ROOM TYPE A
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            160.88 sq.m. (2 Bedroom)
                          </p>

                          <a
                            data-caption="ROOM TYPE A&lt;br /&gt;160.88 sq.m. (2 Bedroom)"
                            href="/assets/floorplan/room-a.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan room a"
                            className="max-w-[575px] w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/room-a.webp"
                              alt="room-a"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>
                        <div
                          className={
                            openTab2 === 2
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link2"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            ROOM TYPE B
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            157.98 sq.m. (2 Bedroom)
                          </p>

                          <a
                            data-caption="ROOM TYPE B&lt;br /&gt;157.98 sq.m. (2 Bedroom)"
                            href="/assets/floorplan/room-b.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan room b"
                            className="max-w-[575px] w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/room-b.webp"
                              alt="room-b"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>

                        <div
                          className={
                            openTab2 === 3
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link3"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            ROOM TYPE C
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            122.36 sq.m. (2 Bedroom)
                          </p>

                          <a
                            data-caption="ROOM TYPE C&lt;br /&gt;122.36 sq.m. (2 Bedroom)"
                            href="/assets/floorplan/room-c.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan room c"
                            className="max-w-[575px] w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/room-c.webp"
                              alt="room-c"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>

                        <div
                          className={
                            openTab2 === 4
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link4"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            ROOM TYPE D
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            126.16 sq.m. (2 Bedroom)
                          </p>

                          <a
                            data-caption="ROOM TYPE D&lt;br /&gt;126.16 sq.m. (2 Bedroom)"
                            href="/assets/floorplan/room-d.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan room d"
                            className="max-w-[575px] w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/room-d.webp"
                              alt="room-d"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>

                        <div
                          className={
                            openTab2 === 5
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link5"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            ROOM TYPE E
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            168.47 sq.m. (2 Bedroom)
                          </p>

                          <a
                            data-caption="ROOM TYPE E&lt;br /&gt;168.47 sq.m. (2 Bedroom)"
                            href="/assets/floorplan/room-e.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan room e"
                            className="max-w-[640px] w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/room-e.webp"
                              alt="room-e"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>

                        <div
                          className={
                            openTab2 === 6
                              ? "flex flex-col items-center"
                              : "hidden"
                          }
                          id="link6"
                        >
                          <p className=" font-bold text-3xl lg:text-4xl  text-[#82603f] text-center font-serif">
                            PENTHOUSE
                          </p>
                          <p className="text-[#7b7c80] font-serif italic text-center  mb-5">
                            392.22 sq.m. (3 Bedroom)
                          </p>

                          <a
                            data-caption="PENTHOUSE&lt;br /&gt;392.22 sq.m. (3 Bedroom)"
                            href="/assets/floorplan/penthouse.webp"
                            data-fancybox="roomtype"
                            aria-label="masterplan penthouse"
                            className="max-w-5xl w-full h-[380px] lg:h-[388px] relative sm:my-5"
                          >
                            <Image
                              src="/assets/floorplan/penthouse.webp"
                              alt="penthouse"
                              sizes="100vw"
                              width={0}
                              height={0}
                              className="w-full h-full object-contain object-center"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul
                    className="flex mb-0 list-none flex-wrap flex-row w-fit justify-center "
                    role="tablist"
                  >
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 1
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(1);
                        }}
                        data-toggle="tab"
                        aria-label="tab 1 click room type"
                        href="#link1"
                        role="tablist"
                      >
                        Room Type A
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 2
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(2);
                        }}
                        data-toggle="tab"
                        aria-label="tab 2 click room type"
                        href="#link2"
                        role="tablist"
                      >
                        Room Type B
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 3
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(3);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        aria-label="tab 3 click room type"
                        role="tablist"
                      >
                        Room Type C
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 4
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(4);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        aria-label="tab 4 click room type"
                        role="tablist"
                      >
                        Room Type D
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 5
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(5);
                        }}
                        data-toggle="tab"
                        aria-label="tab 5 click room type"
                        href="#link2"
                        role="tablist"
                      >
                        Room Type E
                      </a>
                    </li>
                    <li
                      role="tab"
                      className="-mb-px  last:mr-0 flex-auto text-center w-40"
                    >
                      <a
                        className={
                          "text-sm px-5 py-3  block leading-normal " +
                          (openTab2 === 6
                            ? "text-white bg-[#82603f] border border-[#82603f]"
                            : "text-gray-500 hover:text-[#82603f] border border-[#82603f] bg-white ")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab2(6);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        role="tablist"
                        aria-label="tab 6 click room type"
                      >
                        Penthouse
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }

  return (
    <>
      <Fancybox
        options={{
          Carousel: {
            infinite: false,
          },
        }}
      >
        <div className="min-h-screen w-full h-full relative flex flex-col justify-center items-center gap-5 mt-4 md:mt-8 lg:mt-16 pb-16">
          {themes.map((item, index) => (
            <div
              key={index}
              //@ts-ignore
              ref={(e) => (GroupRef.current[index] = e)}
              data-bgcolor={item.theme.background}
              className="w-full h-full relative"
            >
              {ConditionContent(item.title)}
              {/* <ConditionContent contentTitle={item.title} /> */}
            </div>
          ))}
        </div>
      </Fancybox>
    </>
  );
}
